import { Link, useNavigate } from "react-router-dom";
import "../styles/AdminLayout.css";

const AdminLayout = ({ children }) => {
    const navigate = useNavigate();

    const handleLogout = () => {
        localStorage.removeItem("token");
        navigate("/admin/login");
    };

    return (
        <div className="admin-container">
            {/* Боковое меню */}
            <aside className="admin-sidebar">
                <div>
                    <h1>Admin panel</h1>
                    <nav>
                        <ul>
                            <li><Link to="/admin">🏠 Main</Link></li>
                            <li><Link to="/admin/users">👥 Users</Link></li>
                            <li><Link to="/admin/devices">📦 Devices</Link></li>
                            <li><Link to="/admin/news">📰 News</Link></li>
                        </ul>
                    </nav>
                </div>
                <div className="logout-button" onClick={handleLogout}>🚪 Logout</div>
            </aside>

            {/* Основное содержимое */}
            <main className="admin-content">{children}</main>
        </div>
    );
};

export default AdminLayout;
